import { useGetCurrentUser } from 'BrokerTsLib/src/hooks/useUser'
import { useMemo } from 'react'
import { useNavigate } from 'react-router'

import { HeaderButton } from '@/components'
import { ChangePasswordModal } from '@/containers/auth/change-password/ChangePasswordModal'
import { ProfileDetails } from '@/containers/profile/ProfileDetails'
import { UserHeader } from '@/containers/user/UserHeader'
import { useAuth } from '@/context/AuthContext'
import { SidebarProvider } from '@/context/SidebarContext'
import { Edit, Key } from '@/icons'
import { PageWrapper } from '@/layouts/components/PageWrapper'
import { Sidebar } from '@/layouts/components/Sidebar'
import { useDisclosure } from '@chakra-ui/react'
import { Breadcrumbs } from 'BrokerTsLib/src/containers/Breadcrumbs'

export const ProfilePage = () => {
  const { data, isLoading } = useGetCurrentUser()
  const { user } = useAuth()
  const navigate = useNavigate()

  const breadcrumbs = useMemo(() => {
    const items = []

    items.push({
      to: '/organization',
      label: data?.data.organizationUnitName ?? 'Organizace',
      current: !user?.allowDisplayOrganization,
    })

    items.push({
      to: '/profile',
      label: data?.data
        ? data.data.firstName ? `${data.data.firstName} ${data.data.lastName}` : data.data.userName
        : 'Profil',
      current: true,
    })

    return items
  }, [user, data])

  const changePasswordDisclosure = useDisclosure()

  return (
    <SidebarProvider>
      <PageWrapper
        header={
          <>
            <Breadcrumbs items={breadcrumbs} />
            <UserHeader user={data?.data} isLoading={isLoading}>
              {user && (
                <>
                  {data?.data.hasPassword && (<>
                    <HeaderButton onClick={() => changePasswordDisclosure.onOpen()}>
                      <Key />
                      Změnit heslo
                    </HeaderButton>
                    <ChangePasswordModal {...changePasswordDisclosure} />

                  </>)}
                </>
              )}
              {user?.allowEditOrganizationStructure && (
                <HeaderButton
                  onClick={() => navigate(`/user/${data?.data?.userId}/edit`)}
                  variant="solid"
                  colorScheme="primary"
                  _hover={{ bg: 'primary.600' }}
                >
                  <Edit />
                  Upravit
                </HeaderButton>
              )}
            </UserHeader>
          </>
        }
        sidebar={<Sidebar />}
        mainProps={{
          sx: {
            pt: { base: 0, lg: 8 },
            gap: 4,
            display: 'grid',
          },
        }}
      >
        <ProfileDetails user={data?.data} />
      </PageWrapper>
    </SidebarProvider>
  )
}
